"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreeOrBetaAccountInfo = exports.useCancelledAccountInfo = void 0;
const common_1 = require("@saffron/common");
const dayjs_1 = __importDefault(require("dayjs"));
exports.useCancelledAccountInfo = (user, yearly) => {
    const planInfo = common_1.statusToAccountInfoMap[user.role.type];
    const nextPlanInfo = common_1.statusToNextPlanInfo[user.role.type];
    const expirationDate = (user.role.type === common_1.STANDARD_SUBSCRIPTION_CANCELLED_STATUS ||
        user.role.type === common_1.SEASONED_SUBSCRIPTION_CANCELLED_STATUS) &&
        !!user.role.endDate &&
        dayjs_1.default(user.role.endDate).format("MM/DD/YYYY");
    const upgradeCost = "cost" in nextPlanInfo ? nextPlanInfo.cost + (yearly ? 0 : 1) : 0;
    return {
        title: planInfo.name,
        expirationDate,
        cancelledCopy: expirationDate
            ? "When access expires, you may still use your account—but won’t be able to add any new recipes."
            : "You may still use your account—but won’t be able to add any new recipes.",
        costText: upgradeCost === 0
            ? `Contact us for pricing.`
            : `$${upgradeCost} a month ${yearly ? `(billed at $${upgradeCost * 12}/year)` : ``}`,
        upgradeCost,
    };
};
exports.useFreeOrBetaAccountInfo = (user, yearly) => {
    const planInfo = common_1.statusToAccountInfoMap[user.role.type];
    const nextPlanInfo = common_1.statusToNextPlanInfo[user.role.type];
    const recipeLimit = planInfo.recipeLimit.toLocaleString();
    const nextRecipeLimit = nextPlanInfo.recipeLimit.toLocaleString();
    const ratio = `${user.numRecipes.toLocaleString()}/${recipeLimit}`;
    let bodyCopy = "";
    if (user.role.type === common_1.SEASONED_SUBSCRIPTION_STATUS) {
        bodyCopy = "Get in touch know if you need more recipes.";
    }
    else if (user.numRecipes >= planInfo.recipeLimit) {
        bodyCopy = `You’ve reached the recipe limit, to increase it to ${nextRecipeLimit}—upgrade below.`;
    }
    else {
        bodyCopy = `To increase your recipe limit to ${nextRecipeLimit}—upgrade below.`;
    }
    const upgradeCost = "cost" in nextPlanInfo ? nextPlanInfo.cost + (yearly ? 0 : 1) : 0;
    return {
        title: planInfo.name,
        ratio,
        bodyCopy,
        costText: upgradeCost === 0
            ? `Contact us for pricing.`
            : `$${upgradeCost} a month ${yearly ? `(billed at $${upgradeCost * 12}/year)` : ``}`,
        isStandard: user.role.type === common_1.STANDARD_SUBSCRIPTION_STATUS,
        upgradeCost,
    };
};
//# sourceMappingURL=useAccountInfo.js.map